import React from 'react';
import PriceTable from './PriceTable';
import { AUTO_VEHICLE_TYPES, MOTORCYCLE_VEHICLE_TYPES } from '../data/services';

// Auto/motorcycle price tables block extracted from ServiceDetailPage to keep
// the page file under the 300-line hard limit. Renders nothing when both
// flags are false.
export default function ServiceDetailPriceSection({ service, showAutoTable, showMotorcycleTable }) {
  if (!service || (!showAutoTable && !showMotorcycleTable)) return null;
  return (
    <section className="section" style={{ paddingTop: 0 }}>
      <div className="container" style={{ maxWidth: 880 }}>
        {showAutoTable && (
          <>
            <h2 style={{ fontSize: '1.3rem', marginBottom: 16 }}>🚗 자동차 차종별 가격</h2>
            <PriceTable service={service} vehicleTypes={AUTO_VEHICLE_TYPES} />
          </>
        )}
        {showMotorcycleTable && (
          <>
            <h2 style={{ fontSize: '1.3rem', marginTop: showAutoTable ? 32 : 0, marginBottom: 16 }}>
              🏍️ 오토바이 배기량별 가격
            </h2>
            <PriceTable service={service} vehicleTypes={MOTORCYCLE_VEHICLE_TYPES} />
          </>
        )}
        <p style={{
          textAlign: 'center', color: 'var(--text-dim)',
          fontSize: '0.85rem', marginTop: 24,
        }}>
          * 표시된 가격은 부가세 별도입니다
        </p>
      </div>
    </section>
  );
}
